<s1-input-select [control]="control" [itemsList]="categorie" [label]="'categorie.title'" [readonly]="readonly" [multiple]="multiple"></s1-input-select>